export * from './IconKernStroked';
